import {BaseEntityUnDeletable} from '../../../common/entities';

export class MilitaryBranch extends BaseEntityUnDeletable {
    description: string;
}
